<template>
    <svg class="SolarSystem" fill="none" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <!-- Solarsystem Mainmask-->
            <mask id="socialMediaMask">
                <rect fill="white" height="100%" width="100%"/>
                <g>
                    <rect fill="black" height="80" width="500" x="50" y="70"/>
                    <rect fill="black" height="150" width="280" x="160" y="35"/>
                    <rect fill="black" height="190" width="200" x="195" y="0"/>
                    <rect fill="black" height="100" width="500" x="0" y="500"/>
                </g>
            </mask>

            <!-- Outer Ring Mask -->
            <mask id="OuterRingMask">
                <rect fill="white" height="100%" width="100%"/>
                <!--                <g class="fixedFakePlanet">-->
                <!--                    <circle class="number3__dot" cx="522" cy="365" fill="black" r="26"/>-->
                <!--                </g>-->
            </mask>

            <!-- Middle Ring Mask -->
            <mask id="MiddleRingMask">
                <rect fill="white" height="100%" width="100%"/>
                <g class="SharePlanets">
                    <!-- linkedin mask-->
                    <circle cx="125" cy="225" fill="black" r="18" v-if="showActions"/>

                    <!-- postcard mask-->
                    <circle cx="120" cy="365" fill="black" r="18" v-if="showActions"/>

                    <!-- E-Mail mask-->
                    <circle cx="470" cy="220" fill="black" r="18" v-if="showActions"/>

                    <!-- contact mask-->
                    <circle cx="475" cy="370" fill="black" r="18" v-if="showActions"/>
                </g>
            </mask>

            <!-- Inner Ring Mask -->
            <mask id="InnerRingMask">
                <rect fill="white" height="100%" width="100%"/>
                <g class="SharePlanets">
                </g>
            </mask>

            <!-- Facebook Mask -->
            <!--                    <mask id="FacebookMask">-->
            <!--                        <rect fill="white" height="100%" width="100%"/>-->
            <!--                        <g class="facebook" transform="translate(149, 240)">-->
            <!--                            <font-awesome-icon :height="22" :icon="['fab', 'facebook-f']" :width="22"/>-->
            <!--                        </g>-->
            <!--                    </mask>-->

            <!-- Twitter Mask-->
            <!--                    <mask id="TwitterMask">-->
            <!--                        <rect fill="white" height="100%" width="100%"/>-->
            <!--                        <g class="twitter" transform="translate(457, 205)">-->
            <!--                            <font-awesome-icon :height="34" :icon="['fab', 'twitter']" :width="34"/>-->
            <!--                        </g>-->
            <!--                    </mask>-->

            <!-- Linkedin Mask-->
            <mask id="LinkedInMask">
                <rect fill="white" height="100%" width="100%"/>
                <!--                <g class="linkedin" transform="translate(142, 235)">-->
                <g class="linkedin" transform="translate(115, 215)">
                    <font-awesome-icon :height="20" :icon="['fab', 'linkedin-in']" :width="20"/>
                </g>
            </mask>

            <!-- postcard Mask-->
            <mask id="postcardMask" width="20" height="20">
              <rect fill="white" height="100%" width="100%"/>
              <!--                <g class="linkedin" transform="translate(142, 235)">-->
              <g class="linkedin" transform="translate(110, 355)">
                <path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 1.667969 10 L 3.332031 10 L 3.332031 14.167969 L 16.667969 14.167969 L 16.667969 10 L 18.332031 10 L 18.332031 14.167969 C 18.332031 15.089844 17.589844 15.832031 16.667969 15.832031 L 3.332031 15.832031 C 2.417969 15.832031 1.667969 15.089844 1.667969 14.167969 L 1.667969 10 M 10 12.5 L 14.625 7.949219 L 13.441406 6.773438 L 10.832031 9.375 L 10.832031 1.667969 L 9.167969 1.667969 L 9.167969 9.375 L 6.566406 6.773438 L 5.382812 7.957031 Z M 10 12.5 "/>
                <!--                <font-awesome-icon :height="20" :icon="['fab', 'xing']" :width="20"/>-->
              </g>
            </mask>


            <!-- Xing Mask-->
            <!--                    <mask id="XingMask">-->
            <!--                        <rect fill="white" height="100%" width="100%"/>-->
            <!--                        <g class="xing" transform="translate(102, 343)">-->
            <!--                            <font-awesome-icon :height="36" :icon="['fab', 'xing']" :width="36"/>-->
            <!--                        </g>-->
            <!--                    </mask>-->

            <!-- E-Mail Mask-->
            <mask id="MailMask">
                <rect fill="white" height="100%" width="100%"/>
                <g class="mail" transform="translate(460, 215)">
                    <font-awesome-icon :height="20" :icon="['far', 'envelope']" :width="20"/>
                </g>
            </mask>

            <!-- send link Mask-->
<!--            <mask id="SendLinkMask">-->
<!--&lt;!&ndash;                cx="182" cy="390"&ndash;&gt;-->
<!--                <rect fill="white" height="100%" width="100%"/>-->
<!--                <g class="mail" transform="translate(172, 380)">-->
<!--                    <font-awesome-icon :height="20" :icon="['far', 'envelope']" :width="20"/>-->
<!--                </g>-->
<!--            </mask>-->

            <!-- Contact Mask -->
<!--            <mask id="ContactMask">-->
<!--                <rect fill="white" height="100%" width="100%"/>-->
<!--                <g class="mail" transform="translate(290, 390)">-->
<!--                    <polygon fill="#D8D8D8" points="66.585,4.524 64.254,6.317 62.03,4.468 62.03,7.261 66.585,7.261 	"/>-->
<!--                    <polygon fill="#D8D8D8" points="66.137,4.143 62.538,4.143 64.268,5.582 	"/>-->
<!--                    <path fill="#D8D8D8" d="M64.308,1.138c-2.521,0-4.564,2.044-4.564,4.564s2.044,4.564,4.564,4.564s4.564-2.044,4.564-4.564-->
<!--		                S66.828,1.138,64.308,1.138z M67.159,7.836h-5.703V3.569h5.703V7.836z"/>-->
<!--                    <polygon fill="#D8D8D8" points="3.297,7.25 4.73,7.249 5.575,8.583 6.424,7.25 7.851,7.25 7.851,4.143 3.297,4.143 	"/>-->
<!--                    <path fill="#D8D8D8" d="M5.574,1.138c-2.521,0-4.564,2.044-4.564,4.564s2.044,4.564,4.564,4.564s4.564-2.044,4.564-4.564-->
<!--		                S8.095,1.138,5.574,1.138z M2.722,3.569h5.703v4.267L6.673,7.837L5.575,9.481L4.46,7.81L2.722,7.836V3.569z"/>-->
<!--                    <path fill="#D8D8D8" d="M35.075,1.014c-2.521,0-4.564,2.044-4.564,4.564s2.044,4.564,4.564,4.564s4.564-2.044,4.564-4.564-->
<!--                        S37.596,1.014,35.075,1.014z M33.734,7.96h-1.173v-3.5h1.173V7.96z M33.141,4.005c-0.379,0-0.686-0.276-0.686-0.615-->
<!--                        c0-0.34,0.307-0.615,0.686-0.615c0.379,0,0.686,0.276,0.686,0.615C33.827,3.729,33.52,4.005,33.141,4.005z M37.907,7.96h-1.173V6.19-->
<!--                        c0-0.59-0.192-0.885-0.577-0.885h-0.058c-0.032,0-0.09,0.013-0.173,0.038c-0.269,0.087-0.404,0.362-0.404,0.827V7.96h-1.173v-3.5-->
<!--                        h1.173v0.442h0.038c0.224-0.359,0.564-0.538,1.019-0.538c0.163,0.013,0.317,0.039,0.462,0.077c0.577,0.228,0.865,0.728,0.865,1.5-->
<!--                        V7.96z"/>-->
<!--                </g>-->
<!--            </mask>-->
        </defs>


        <g class="InnerSolarSystem" mask="url('#socialMediaMask')">

            <!-- Orbit -->
            <g id="Orbit" stroke-width="2">
                <circle cx="300" cy="300" id="outer__circle" mask="url(#OuterRingMask)" r="230"
                        stroke="#FFFFFF" stroke-linejoin="bevel"></circle>
                <circle cx="300" cy="300" id="middle__circle" mask="url(#MiddleRingMask)" r="190"
                        stroke="#FFFFFF" stroke-dasharray="0,8" stroke-linecap="round"
                        stroke-linejoin="round"></circle>
                <circle cx="300" cy="300" id="inner__circle" mask="url(#InnerRingMask)" r="150"
                        stroke="#FFFFFF" stroke-dasharray="0,8" stroke-linecap="round"
                        stroke-linejoin="round"></circle>
            </g>

            <!-- Fake Rotating Planets-->
            <g class="FakePlanets">
                <g class="outer__ring">
                    <circle class="spinning left" cx="503" cy="408" fill="#523514" id="brown__dot" r="8"/>
                </g>
                <g class="middle__ring">
                    <circle class="spinning left" cx="162" cy="170" fill="#166868" id="ment__dot" r="9"/>
                    <circle class="spinning left" cx="139" cy="400" fill="#526226" id="darkgreen__dot-" r="6"/>
                </g>
                <g class="inner__ring">
                    <circle class="spinning left" cx="150" cy="300" fill="#9D314E" id="viollet__dot" r="4"/>
                    <circle class="spinning left" cx="280" cy="448" fill="#BAB13C" id="green__dot" r="6"/>
                </g>
            </g>

            <!-- Fixed Number Planets-->
            <!--            <g class="fixedFakePlanet">-->
            <!--                <circle class="number3__dot" cx="522" cy="365" fill="#4BB699" r="22"/>-->
            <!--                <text fill="#FFFFFF" x="514" y="375">3</text>-->
            <!--            </g>-->

            <!-- Socialmedia Planets -->
            <g class="SharePlanets">

                <!-- Facebook -->
                <!--                        <circle class="facebook__planet rotating__planet&#45;&#45;small" cx="160" cy="250" fill="#D8D8D8"-->
                <!--                                mask="url('#FacebookMask')"-->
                <!--                                r="14" v-on:click="share('facebook')"/>-->

                <!-- Twitter -->
                <!--                        <circle class="twitter__planet rotating__planet&#45;&#45;big" cx="472" cy="220" fill="#D8D8D8"-->
                <!--                                mask="url('#TwitterMask')"-->
                <!--                                r="22"-->
                <!--                                v-on:click="share('twitter')"/>-->

                <!-- Linkedin Mask -->
                <g class="link-planet" v-on:click="share('linkedin')" v-if="showActions">
                    <circle class="linkedin__planet" cx="125" cy="225" fill="#D8D8D8" mask="url('#LinkedInMask')"
                            r="14"/>
                    <foreignObject width="145px" height="40px" x="55" y="250">
                        <body class="action_bg">
                        <button class="action-btn">{{ $t('buttons.actions.share-linkedin') }}</button>
                        </body>
                    </foreignObject>
                </g>

                <!-- postcard Mask -->
                <g class="link-planet" v-on:click="download" v-if="showActions">
                  <circle class="postcard__planet" cx="120" cy="365" fill="#D8D8D8" mask="url('#postcardMask')"
                          r="14"/>
                  <foreignObject width="190px" height="40px" x="25" y="390">
                    <body class="action_bg">
                    <button class="action-btn">{{ $t('buttons.download') }}</button>
                    </body>
                  </foreignObject>
                </g>

                <!-- Xing Mask -->
                <!--                        <circle class="xing__planet" cx="120" cy="360" fill="#D8D8D8" mask="url('#XingMask')"-->
                <!--                                r="22"-->
                <!--                                v-on:click="share('xing')"/>-->

                <!-- E-Mail Mask -->
                <g class="link-planet" v-on:click="share('link')" v-if="showActions">
                    <circle class="mail__planet" cx="470" cy="225" fill="#D8D8D8" mask="url('#MailMask')"
                            r="14"/>
                    <foreignObject width="170px" height="40px" x="385" y="250">
                        <body class="action_bg">
                        <button class="action-btn">{{ $t('buttons.actions.create-link') }}</button>
                        </body>
                    </foreignObject>
                </g>

                <!-- send link Mask -->
<!--                <g class="link-planet" v-on:click="openMail" v-if="shareStatus == 2">-->
<!--                    <circle class="mail__planet" cx="182" cy="390" fill="#D8D8D8" mask="url('#SendLinkMask')"-->
<!--                            r="14"/>-->
<!--                </g>-->

                <!-- contact Mask -->
                <g class="link-planet" v-on:click="share('contact')" v-if="showActions">
                    <g class="mail" transform="translate(460, 355)">
                        <svg width="28px" height="28px" viewBox="0 0 20 20"  >
                            <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="Path" transform="translate(-40.000000, -40.000000)" fill="#FFFFFF">
                                    <path d="M50,40 C55.5228475,40 60,44.4771525 60,50 C60,55.5228475 55.5228475,60 50,60 C44.4771525,60 40,55.5228475 40,50 C40,44.4771525 44.4771525,40 50,40 Z M56.6666667,44.4444444 L43.3333333,44.4444444 L43.3333333,54.0678094 L47.3966918,54.0091716 L50.0035069,57.7777778 L52.5705769,54.0700647 L56.6666667,54.0678094 L56.6666667,44.4444444 Z M55.4701981,45.5555556 L55.4701981,53.0938581 L52.1247297,53.0956247 L50.1138582,56 L48.071853,53.0479251 L44.5821776,53.0938581 L44.5821776,45.5555556 L55.4701981,45.5555556 Z" id="Combined-Shape"></path>
                                </g>
                            </g>
                        </svg>
                    </g>
                    <g>
                        <foreignObject width="160px" height="40px" x="390" y="395" clas="aligner_center">
                            <body class="action_bg -center">
                            <button class="action-btn">{{ $t('buttons.actions.contact') }}</button>
                            </body>
                        </foreignObject>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
  export default {
    name: 'SolarSystem',
    props: {
      showActions: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      shareStatus () {
        return this.$store.getters.shareStatus
      },

      shareUrl() {
        return this.$store.getters.shareUrl
      },

      curRecipe () {
        return this.$store.state.curRecipe
      }
    },
    methods: {
      share (platform) {
        // let link = this.platforms[platform];
        //
        // // ensure platform share link exists
        // if (link === undefined)
        //   return;

        // // generate title
        // let title = encodeURIComponent(this.$t('share.share-title') + this.curRecipe.name);
        //
        // // check for mail
        // if (platform === 'mail') {
        //   let email = this.$store.state.contactEmail;
        //   window.location.href = 'mailto:' + email + '?subject=' + title + '&body=' + this.shareUrl;
        // } else {
        //   // apply share link
        //   link = link.replace('###url###', this.shareUrl);
        //
        //   // apply share title
        //   link = link.replace('###title###', title);
        //
        //   // open new window
        //   window.open(link, '_blank');
        // }

        this.$emit('userInteraction', platform)
      },

      download() {
        this.$store.dispatch('saveRecipe')
            .then((response) => {
              window.setTimeout(function () {
                window.open('/postcard/' + response.data.data.hash.substr(3) + '_' + response.data.data.name + '.jpg', '_blank').focus();
              }, 50);

            })
      },

      openMail() {
        window.location.href = 'mailto:?subject=' + encodeURIComponent(this.$t('share.share-title') + ' ' + this.curRecipe.name) + '&body=' + this.shareUrl;
      }
    }
  }
</script>
